import utils from "../../../utils/utils.js";

export default {
  async fetchSuperUserFaqs(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetFaqs?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setSuperUserFaqs", responseData.data);
  },
  async fetchSuperUserFaqTypes(context) {
    const response = await utils.utility.fetch(
      `api/Setting/GetFaqTypes`,
      "GET",
      null,
      null
    );

    context.commit("setSuperUserFaqTypes", response.data);
  },

  async postSuperUserFaq(context, payload) {
    await utils.utility.fetch(`api/Setting/CreateFaq`, "POST", null, payload);
  },
  async putSuperUserFaq(context, payload) {
    await utils.utility.fetch(`api/Setting/UpdateFaq`, "PUT", null, payload);
  },

  async deleteSuperUserFaq(context, payload) {
    let postData = { id: payload.id };
    await utils.utility.fetch(`api/Setting/DeleteFaq`, "POST", null, postData);
  },
};
